module.exports = __webpack_public_path__ + "static/media/preston_1.bc7d5bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/preston_1.png
// module id = 452
// module chunks = 0